import styled from 'styled-components';

export const FareTrendContainer = styled.div`
  background-color: #2276e3;
  /* background-image: 'linear-gradient(to bottom, #2276e3, #134280)'; */
`;

export const FareTrendWrap = styled.div(
  props => `
    padding-bottom: 2px;
    overflow-x: auto;
    width: 100%;
    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    `
);

export const FTBlock = styled.div`
  width: 5.4rem;
  background-color: ${props => (props.isSelected ? '#0a3061' : '#ffffff')};
  border-radius: 0.5rem 0.5rem 0 0;
  margin-right: 0.2rem;
`;

export const FTPrice = styled.div`
  color: ${props =>
    props.isMax
      ? '#db3333'
      : props.isLowest
      ? '#05a441'
      : props.isSelected
      ? '#ffffff'
      : '#141823'};
  padding-top: ${props => props.theme.spacing.custom(2)};
`;

export const FTDay = styled.div`
  color: ${props => (props.isSelected ? '#ffffff' : '#717171')};
  font-size: ${props => props.theme.font.custom(11)};
`;

export const FTMonth = styled.div`
  text-orientation: upright;
  writing-mode: vertical-rl;
  color: #ffffff;
  /* box-shadow: 2px -11px 6px -1px rgba(25, 32, 113, 0.33); */
  box-shadow: 6px -2px 6px -1px rgb(25 32 113 / 33%);
`;

export const FTCal = styled.div`
  color: #ffffff;
  width: 9%;
  box-shadow: 5px 0 5px -5px rgba(25, 32, 113, 0.33);
  z-index: 1;
`;
